<template>
  <div class="product-donate-type-wrapper" v-if="product">
    <div class="product-donate-type">
      <div class="donate-type-item">
        <div class="control">
          <input type="radio" name="donate_type" v-model="type" value="onetime" />
          <label class="label label--left onetime">บริจาคครั้งเดียว</label>
        </div>
      </div>
      <div class="donate-type-item" v-if="recurringEnabled">
        <div class="control">
          <input type="radio" name="donate_type" v-model="type" value="monthly" />
          <label class="label label--right monthly">บริจาคเป็นรายเดือน</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductDonateType',

    props: {
      product: {
        type: Object,
        default: null
      },
      value: {
        type: String,
        default: 'monthly'
      }
    },

    data () {
      return {
        type: ''
      }
    },

    created () {
      this.type = this.value
      this.$store.dispatch('setDonateType', this.type)
    },

    computed: {
      recurringEnabled () {
        return this.product && this.product.meta && this.product.meta.donation_amount_monthly
      }
    },

    watch: {
      'type': function (newValue) {
        this.$store.dispatch('setDonateType', newValue)
        this.$emit('input', newValue)
      }
    }
  }
</script>

<style scoped lang="scss">
  .product-donate-type-wrapper {

    margin-bottom: 20px;

    .product-donate-type {
      display: flex;
      display: -webkit-flex;
      .donate-type-item {
        flex: 1;
        font-weight: 400;
        font-size: 0.85em;
        line-height: 1.5em;
      }
    }

    .control {
      position:relative;
      .label {
        color: #868686;
        background: #E3E3E3;
        min-height: 58px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border: 1px solid #ABABAB;
        &--left {
          border-right: 0;
          -webkit-border-top-left-radius: 5px;
          -webkit-border-bottom-left-radius: 5px;
          -moz-border-radius-topleft: 5px;
          -moz-border-radius-bottomleft: 5px;
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
        }
        &--right {
          border-left: 0;
          -webkit-border-top-right-radius: 5px;
          -webkit-border-bottom-right-radius: 5px;
          -moz-border-radius-topright: 5px;
          -moz-border-radius-bottomright: 5px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }
      }

      input[type="radio"]{
        cursor: pointer;
        position:absolute;
        width:100%;
        height:100%;
        z-index: 999;
        opacity: 0;
        &:checked + .label {
          z-index: 1;
          background: #F8941D;
          color: #fff;
          -moz-box-shadow:    inset 0 0 8px rgba(0,0,0,.3);
          -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,.3);
          box-shadow:         inset 0 0 8px rgba(0,0,0,.3);
        }
      }
    }
  }

  @media (min-width: 360px) {
    .product-donate-type-wrapper {
      .product-donate-type {
        .donate-type-item {
          font-size: 1em;
        }
      }
    }
  }

  @media (min-width: 425px) {
    .product-donate-type-wrapper {
      .control {
        .label {
          &:before {
            content: " ";
            background: url("../assets/img/ic-onetime-gray@2x.png") no-repeat left center;
            background-size: 100%;
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }
        }
        .onetime:before { background: url("../assets/img/ic-onetime-gray@2x.png") no-repeat left center; background-size: 100%;}
        .monthly:before { background: url("../assets/img/ic-monthly-gray@2x.png") no-repeat left center; background-size: 100%;}

        input[type="radio"]:checked + .label {
          &:before {
            content: " ";
            background: url("../assets/img/ic-onetime-white@2x.png") no-repeat left center;
            background-size: 100%;
          }
        }

        input[type="radio"]:checked + .onetime:before { background: url("../assets/img/ic-onetime-white@2x.png") no-repeat left center; background-size: 100%;}
        input[type="radio"]:checked + .monthly:before { background: url("../assets/img/ic-monthly-white@2x.png") no-repeat left center; background-size: 100%;}
      }

    }
  }

</style>



// WEBPACK FOOTER //
// ProductDonateType.vue?824e8288